export const censusReportPath = {
  RETRIEVE: '/census/batch/retrieve',
  PULL: '/census/pull',
};
